import * as React from 'react';
import './progressbar.scss';

interface Props {
  currentStep: number;
  totalSteps: number;
}

export const ProgressBar = ({ currentStep, totalSteps }: Props): JSX.Element => {
  const style = { '--progress-position': 100 - (currentStep / totalSteps) * 100 + '%' } as React.CSSProperties;
  return (
    <div className={'progress-bar'}>
      <div style={style} className={'progress-bar-indicator progress-current-' + currentStep} />
    </div>
  );
};
export default ProgressBar;
